import { Alert, Box, Button, Paper, TextField } from '@mui/material';
import { useState } from 'react';
import type { FormEvent } from 'react';
import { PageHeader } from '../../components/PageHeader';
import { errorMessage } from '../../lib/api';
import { useUnlockByLoginId } from './api';

/** Settings > Unlock User (PC238): clear the lock on an account by user name. */
export function UnlockUserPage() {
  const [loginId, setLoginId] = useState('');
  const unlock = useUnlockByLoginId();

  const submit = (e: FormEvent) => {
    e.preventDefault();
    unlock.mutate(loginId.trim(), { onSuccess: () => setLoginId('') });
  };

  return (
    <Box>
      <PageHeader title="Unlock User" code="PC238" />
      <Paper variant="outlined" component="form" onSubmit={submit} sx={{ p: 2, maxWidth: 480 }}>
        <TextField
          label="User Name"
          required
          value={loginId}
          onChange={(e) => {
            setLoginId(e.target.value);
            unlock.reset();
          }}
          slotProps={{ htmlInput: { maxLength: 30 } }}
          sx={{ mb: 2 }}
        />
        <Button type="submit" variant="contained" disabled={!loginId.trim() || unlock.isPending}>
          Submit
        </Button>
        {unlock.isSuccess ? (
          <Alert severity={unlock.data.wasLocked ? 'success' : 'info'} sx={{ mt: 2 }}>
            {unlock.data.wasLocked
              ? `${unlock.data.loginId} has been unlocked.`
              : `${unlock.data.loginId} was not locked.`}
          </Alert>
        ) : null}
        {unlock.isError ? (
          <Alert severity="error" sx={{ mt: 2 }}>
            {errorMessage(unlock.error)}
          </Alert>
        ) : null}
      </Paper>
    </Box>
  );
}
